var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 1366",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pan-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PAN"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m517.5 360.7c-2.1-4.9-0.9-10.6 2.8-14.3l154.8-154.8c5.1-5.1 13.4-5.1 18.5 0l154.8 154.8c3.7 3.7 4.8 9.4 2.8 14.3-2 4.9-6.8 8.1-12.1 8.1h-82.1v160.7c0 7.3-5.9 13.1-13.1 13.1h-119.1c-7.2 0-13.1-5.8-13.1-13.1v-160.7h-82.1c-5.3 0-10.1-3.2-12.1-8.1zm43.7-18.2h63.6c7.3 0 13.1 5.9 13.1 13.2v160.7h92.9v-160.7c0-7.3 5.8-13.2 13.1-13.2h63.5l-123.1-123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m547.2 739.3h-160.7v82.1c0 5.3-3.2 10.1-8.1 12.1-1.6 0.7-3.3 1-5 1-3.4 0-6.8-1.3-9.3-3.9l-154.8-154.7c-2.4-2.5-3.8-5.8-3.8-9.3 0-3.5 1.4-6.8 3.8-9.2l154.8-154.8c3.7-3.8 9.4-4.9 14.3-2.8 4.9 2 8.1 6.8 8.1 12.1v82.1h160.7c7.3 0 13.2 5.9 13.2 13.1v119c0 7.3-5.9 13.2-13.2 13.2zm-13.1-119.1h-160.7c-7.3 0-13.1-5.9-13.1-13.1v-63.6l-123.1 123.1 123.1 123.1v-63.6c0-7.2 5.8-13.1 13.1-13.1h160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m851.2 972.6c2 4.9 0.9 10.5-2.8 14.3l-154.8 154.7c-2.5 2.6-5.9 3.9-9.3 3.9-3.3 0-6.7-1.3-9.2-3.9l-154.8-154.7c-3.7-3.8-4.9-9.4-2.8-14.3 2-4.9 6.8-8.1 12.1-8.1h82.1v-160.8c0-7.2 5.9-13.1 13.1-13.1h119.1c7.2 0 13.1 5.9 13.1 13.1v160.8h82.1c5.3 0 10.1 3.2 12.1 8.1zm-43.8 18.1h-63.5c-7.3 0-13.1-5.9-13.1-13.1v-160.8h-92.9v160.8c0 7.2-5.8 13.1-13.1 13.1h-63.6l123.1 123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m1163.2 666.6c0 3.5-1.4 6.8-3.9 9.3l-154.7 154.7c-2.5 2.6-5.9 3.9-9.3 3.9-1.7 0-3.4-0.3-5-1-4.9-2-8.1-6.8-8.1-12.1v-82.1h-160.8c-7.2 0-13.1-5.9-13.1-13.2v-119c0-7.2 5.9-13.1 13.1-13.1h160.8v-82.1c0-5.3 3.2-10.1 8.1-12.1 4.9-2.1 10.5-1 14.3 2.8l154.7 154.8c2.5 2.4 3.9 5.7 3.9 9.2zm-31.7 0l-123.1-123.1v63.6c0 7.2-5.8 13.1-13.1 13.1h-160.8v92.8h160.8c7.3 0 13.1 5.9 13.1 13.1v63.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPan);
export default __webpack_public_path__ + "static/media/pan.45813963d5d312537cd0a580ab6a0a32.svg";
export { ForwardRef as ReactComponent };